import React from "react";
import "./placeholders.css";

interface ComingSoonScreenProps {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  cardTitle: string;
  cardBody: string;
}

/**
 * Generic centered "coming soon" placeholder (FE-7): a view header + a single
 * dashed card (icon, title, explainer). Shared by Kampagnen and Settings.
 */
export const ComingSoonScreen: React.FC<ComingSoonScreenProps> = ({
  title,
  subtitle,
  icon,
  cardTitle,
  cardBody,
}) => (
  <div className="shell-content-narrow">
    <div className="view-header">
      <h1 className="view-title">{title}</h1>
      {subtitle && <p className="view-subtitle">{subtitle}</p>}
    </div>

    <div className="ph-card">
      <span className="ph-card-icon">{icon}</span>
      <div className="ph-card-title">{cardTitle}</div>
      <p className="ph-card-body">{cardBody}</p>
    </div>
  </div>
);
